import { render, staticRenderFns } from "./exercicioPergunta.vue?vue&type=template&id=e00286e0&"
import script from "./exercicioPergunta.vue?vue&type=script&lang=js&"
export * from "./exercicioPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports